var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PopoverMenu',{attrs:{"position":_vm.position,"float":['right'],"items":_vm.popoverItems,"closest":_vm.closest,"auto-close":""},on:{"toggle":function($event){return _vm.$emit('toggle', $event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return _c('span',{on:{"click":item.action}},[_vm._v(_vm._s(item.label))])}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }